<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('offer') }}</div>
      <div>
        <button
          class="btn-blue"
          @click.prevent.stop="onEditOffer(offerDetails.ot_id)"
        >{{ $t('edit') }}</button>
        <router-link class="btn-blue" to="offer-types">{{ $t('offer') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('offer') }} {{ $tc('type') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="offerDetails.ot_offer_type" class="mr-3">{{offerDetails.ot_offer_type}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('marketingtype') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="selected.marketing_type" class="mr-3">{{selected.marketing_type}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('offer') }} {{ $tc('active') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="offerDetails.offer_is_active=='Y'" class="mr-3">{{$t('yes')}}</span>
            <span v-else class="mr-3">{{$t('no')}}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="offerDetails.created_at"
              class="mr-3"
            >{{offerDetails.created_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="offerDetails.created_by" class="mr-3">{{offerDetails.created_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="offerDetails.updated_at"
              class="mr-3"
            >{{offerDetails.updated_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="offerDetails.updated_by" class="mr-3">{{offerDetails.updated_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";

const selected = {
  marketing_type: ""
};

export default {
  data() {
    return {
      roleID: "",
      ot_id: "",
      marketing_types: [],
      marketing_typesMethod: {
        GET: "/admin/",
        tableName: "ms_marketing_types",
        urlKey: "marketing_types"
      },
      selected: selected,
      items: [],
      offerDetails: []
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;
    const { ot_id } = this.$route.query;

    // this.getCountriesList();

    if (ot_id) {
      this.getOfferDetails(ot_id);
    } else {
      const { ot_id } = this.$route.query;
      this.ot_id = this.$route.query.user_id;

      if (ot_id) {
        this.getOfferDetails(ot_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {},
  methods: {
    getOfferDetails: function(ot_id) {
      MarketingService.getSingleOfferDetails({ ot_id }).then(response => {
        const { data } = response;
        if (data.Records) {
          this.offerDetails = {
            ...this.offerDetails,
            ...data.Records[0]
          };
          // console.log("offerDetails :", this.offerDetails);
          this.getMarketingList(this.offerDetails.marketing_type_id || null);
        }
      });
    },
    onEditOffer: function(ot_id) {
      this.$router.push({
        path: "/marketing/edit-offer-Types",
        query: { ot_id: ot_id }
      });
      // console.log("bank_id :", bank.bank_id);
    },
    getMarketingList: function(mkt_id) {
      this.marketing_types = [];
      let body = this.getRequestBody(
        "GET",
        undefined,
        this.marketing_typesMethod
      );
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.marketing_types = data.Records;
            if (mkt_id) {
              this.marketing_types.map(x => {
                if (mkt_id === x.mkt_id) {
                  this.selected.marketing_type = x.mkt_title;
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferComponents/viewOfferTypes.vue